import React from 'react';
import { Route } from 'react-router-dom';
import { AuthConsumer } from '../../providers/AuthProvider';
import Loader from '../../helpers/loader-full';

export const PrivateRoute = ({ component, ...rest }) => {
    const renderFn = (Component) => (props) => (
        <AuthConsumer>
            {
                ({ isAuthenticated, signinRedirect }) => {
                    if (!!Component && isAuthenticated())
                        return <Component {...props} />
                        
                    else {
                        console.log(signinRedirect);
                        signinRedirect();
                        return <Loader />;
                    }
                }
            }
        </AuthConsumer>
    );

    return <Route {...rest} render={renderFn(component)} />
}